"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUrlFromConfig = getUrlFromConfig;
exports["default"] = void 0;

function getUrlFromConfig(config) {
  var url = config.url;
  var apiPath = config.apiPath,
      rootUrl = config.rootUrl;

  if (!url) {
    url = "".concat(rootUrl, "/").concat(apiPath.replace(/^\//, ''));
  }

  return url;
}

var _default = getUrlFromConfig;
exports["default"] = _default;